// Güncelleneceği zaman UYAP a gir taraflar ödeme kısmına gel console u açıp
// JSON.stringify(harcMasrafListJson) yapip buraya ekle
// Eski eIcrapro'dan yeni eIcrapro Vue + TypeScript yapısına tam çeviri

export interface HarcMasrafItem {
    harcMasraf?: string;
    harcMasrafAdi: string;
    harcMasrafKod?: string;
    harcMasrafKodStr: string;
    harcTip?: string;
    harcMasrafOran?: string;
    harcMasrafBedel?: string;
    harcMasrafBedelMiOranMi: string;
    harcMasrafAltSiniri?: string;
    adet: number;
    tutar: string | number;
    tahsilatHarcOrani?: string;
    otomatikIliskilendirme?: string;
}

export interface TahsilatHarcOrani {
    kayitId: string;
    aciklama: string;
    oran: number;
}

export interface HarcMasrafFormData {
    harcMasraf: string;
    harcMasrafAdi: string;
    harcMasrafKod: string;
    harcMasrafKodStr: string;
    harcTip: string;
    harcMasrafOran: string;
    harcMasrafBedel: string;
    harcMasrafBedelMiOranMi: string;
    harcMasrafAltSiniri: string;
    adet: number;
    tutar: string;
    toplamTutar: string;
    tutarDisabled: boolean;
    pesinHarcDisabled: boolean;
    harcOraniDisabled: boolean;
    otomatikIliskilendirmeText: string;
}

export const harcMasrafListJson = {
    "0": {
        "harcMasrafKodStr": "0",
        "harcMasraf": "T",
        "harcMasrafAdi": "Borç Tahsilatı",
        "tahsilatHarcOrani": "true",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "true"
    },
    "1": {
        "harcMasrafKodStr": "1",
        "harcMasraf": "T",
        "harcMasrafAdi": "Masraf Avansı Tahsilatı",
        "tahsilatHarcOrani": "false",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "false"
    },
    "2": {
        "harcMasrafKodStr": "2",
        "harcMasraf": "T",
        "harcMasrafAdi": "Diğer Teminat Bedeli Tahsilatı",
        "tahsilatHarcOrani": "true",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "false"
    },
    "3": {
        "harcMasrafKodStr": "3",
        "harcMasraf": "T",
        "harcMasrafAdi": "Satış Bedeli Tahsilatı",
        "tahsilatHarcOrani": "true",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "false"
    },
    "5": {
        "harcMasrafKodStr": "5",
        "harcMasraf": "T",
        "harcMasrafAdi": "Bilirkişi Tahsilatı",
        "tahsilatHarcOrani": "false",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "false"
    },
    "8": {
        "harcMasrafKodStr": "8",
        "harcMasraf": "T",
        "harcMasrafAdi": "İhale Teminat Bedeli Tahsılatı",
        "tahsilatHarcOrani": "true",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "false"
    },
    "10": {
        "harcMasrafKodStr": "10",
        "harcMasraf": "T",
        "harcMasrafAdi": "Masraf Avansı (Taşıt Ücreti) Tahsilatı",
        "tahsilatHarcOrani": "false",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "false"
    },
    "11": {
        "harcMasrafKodStr": "11",
        "harcMasraf": "T",
        "harcMasrafAdi": "Masraf Avansı (Satış Avansı) Tahsilatı",
        "tahsilatHarcOrani": "false",
        "harcMasrafBedelMiOranMi": "B",
        "adet": 1,
        "tutar": 0,
        "otomatikIliskilendirme": "false"
    },
    "harcList": [
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Başvurma Harcı",
            "harcMasrafKod": "12805",
            "harcMasrafKodStr": "144197",
            "harcTip": "0",
            "harcMasrafOran": "",
            "harcMasrafBedel": "615.4",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "615.4"
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Cezaevi (Maktu)",
            "harcMasrafKod": "12806",
            "harcMasrafKodStr": "144199",
            "harcTip": "15",
            "harcMasrafOran": "",
            "harcMasrafBedel": "307.7",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "307.7"
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Cezaevi (Nispi)",
            "harcMasrafKod": "13056",
            "harcMasrafKodStr": "14851",
            "harcTip": "4",
            "harcMasrafOran": "2",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Haciz, Teslim ve Satış Harcı",
            "harcMasrafKod": "22784",
            "harcMasrafKodStr": "144204",
            "harcTip": "27",
            "harcMasrafOran": "",
            "harcMasrafBedel": "1445",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "1445"
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "İflas Başvurma Harcı",
            "harcMasrafKod": "12807",
            "harcMasrafKodStr": "144198",
            "harcTip": "25",
            "harcMasrafOran": "",
            "harcMasrafBedel": "1013.9",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "1013.9"
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "İflas Defter Tutma Harçları",
            "harcMasrafKod": "13312",
            "harcMasrafKodStr": "144203",
            "harcTip": "25",
            "harcMasrafOran": "",
            "harcMasrafBedel": "945.4",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "945.4"
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Peşin Harç",
            "harcMasrafKod": "12808",
            "harcMasrafKodStr": "14603",
            "harcTip": "2",
            "harcMasrafOran": "0.5",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "0",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Suret Harcı",
            "harcMasrafKod": "12811",
            "harcMasrafKodStr": "144202",
            "harcTip": "14",
            "harcMasrafOran": "",
            "harcMasrafBedel": "31.8",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "31.8"
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahliye Harcı (%2.275)",
            "harcMasrafKod": "12812",
            "harcMasrafKodStr": "144193",
            "harcTip": "3",
            "harcMasrafOran": "2.275",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahliye Harci(%1.135)",
            "harcMasrafKod": "12813",
            "harcMasrafKodStr": "144192",
            "harcTip": "3",
            "harcMasrafOran": "1.135",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harcı (% 9.10 )",
            "harcMasrafKod": "21248",
            "harcMasrafKodStr": "52750",
            "harcTip": "5",
            "harcMasrafOran": "9.1",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harcı (Haricen %2.275)",
            "harcMasrafKod": "12814",
            "harcMasrafKodStr": "144183",
            "harcTip": "33",
            "harcMasrafOran": "2.275",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harcı (Haricen %4.55)",
            "harcMasrafKod": "12815",
            "harcMasrafKodStr": "54273",
            "harcTip": "33",
            "harcMasrafOran": "4.55",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harcı (Vazgeçme 2.275)",
            "harcMasrafKod": "15876",
            "harcMasrafKodStr": "144185",
            "harcTip": "33",
            "harcMasrafOran": "2.275",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harcı (Vazgeçme %4.55)",
            "harcMasrafKod": "15880",
            "harcMasrafKodStr": "52752",
            "harcTip": "33",
            "harcMasrafOran": "4.55",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harcı (%11.38 Satış Sonrası)",
            "harcMasrafKod": "14336",
            "harcMasrafKodStr": "52749",
            "harcTip": "5",
            "harcMasrafOran": "11.38",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harci 492 S.K.nun 1. ST., B,I,3/h bendi geregi % 0,56",
            "harcMasrafKod": "25092",
            "harcMasrafKodStr": "72563",
            "harcTip": "25",
            "harcMasrafOran": "0.56",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harci 492 S.K.nun 1. ST., B,I,3/h bendi geregi % 1,1375",
            "harcMasrafKod": "25093",
            "harcMasrafKodStr": "72561",
            "harcTip": "25",
            "harcMasrafOran": "1.1375",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harci 492 S.K.nun 1. ST., B,I,3/h bendi gereği % 2,2750",
            "harcMasrafKod": "25094",
            "harcMasrafKodStr": "72562",
            "harcTip": "25",
            "harcMasrafOran": "2.275",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Tahsil Harci 492 S.K.nun 1. ST., B,I,3/h bendi gereği % 2,845",
            "harcMasrafKod": "25095",
            "harcMasrafKodStr": "72560",
            "harcTip": "25",
            "harcMasrafOran": "2.845",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Vekalet Suret Harcı",
            "harcMasrafKod": "12809",
            "harcMasrafKodStr": "144200",
            "harcTip": "14",
            "harcMasrafOran": "",
            "harcMasrafBedel": "87.5",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "87.5"
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Yenilemede Peşin Harç",
            "harcMasrafKod": "15616",
            "harcMasrafKodStr": "19968",
            "harcTip": "26",
            "harcMasrafOran": "0.5",
            "harcMasrafBedel": "",
            "harcMasrafBedelMiOranMi": "O",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": ""
        },
        {
            "harcMasraf": "H",
            "harcMasrafAdi": "Yerine Getirme Harcı",
            "harcMasrafKod": "12810",
            "harcMasrafKodStr": "144201",
            "harcTip": "3",
            "harcMasrafOran": "",
            "harcMasrafBedel": "615.4",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafAltSiniri": "",
            "adet": 1,
            "tutar": "615.4"
        }
    ] as HarcMasrafItem[],
    "masrafList": [] as HarcMasrafItem[],
    "digerList": [
        {
            "harcMasrafKodStr": "4000",
            "harcMasrafAdi": "Vekalet Pulu",
            "harcMasrafBedelMiOranMi": "B",
            "harcMasrafBedel": "138",
            "adet": 1,
            "tutar": "138"
        }
    ] as HarcMasrafItem[],
    "tahsilatList": [
        {
            "harcMasrafKodStr": "0",
            "harcMasraf": "T",
            "harcMasrafAdi": "Borç Tahsilatı",
            "tahsilatHarcOrani": "true",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "true"
        },
        {
            "harcMasrafKodStr": "1",
            "harcMasraf": "T",
            "harcMasrafAdi": "Masraf Avansı Tahsilatı",
            "tahsilatHarcOrani": "false",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "false"
        },
        {
            "harcMasrafKodStr": "2",
            "harcMasraf": "T",
            "harcMasrafAdi": "Diğer Teminat Bedeli Tahsilatı",
            "tahsilatHarcOrani": "true",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "false"
        },
        {
            "harcMasrafKodStr": "3",
            "harcMasraf": "T",
            "harcMasrafAdi": "Satış Bedeli Tahsilatı",
            "tahsilatHarcOrani": "true",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "false"
        },
        {
            "harcMasrafKodStr": "5",
            "harcMasraf": "T",
            "harcMasrafAdi": "Bilirkişi Tahsilatı",
            "tahsilatHarcOrani": "false",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "false"
        },
        {
            "harcMasrafKodStr": "8",
            "harcMasraf": "T",
            "harcMasrafAdi": "İhale Teminat Bedeli Tahsılatı",
            "tahsilatHarcOrani": "true",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "false"
        },
        {
            "harcMasrafKodStr": "10",
            "harcMasraf": "T",
            "harcMasrafAdi": "Masraf Avansı (Taşıt Ücreti) Tahsilatı",
            "tahsilatHarcOrani": "false",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "false"
        },
        {
            "harcMasrafKodStr": "11",
            "harcMasraf": "T",
            "harcMasrafAdi": "Masraf Avansı (Satış Avansı) Tahsilatı",
            "tahsilatHarcOrani": "false",
            "harcMasrafBedelMiOranMi": "B",
            "adet": 1,
            "tutar": 0,
            "otomatikIliskilendirme": "false"
        }
    ] as HarcMasrafItem[]
};

export const tahsilHarcOranlariListJson: Record<string, TahsilatHarcOrani> = {
    "1": { kayitId: "1", oran: 2.275, aciklama: "% 2.275" },
    "2": { kayitId: "2", oran: 4.55, aciklama: "% 4.55" },
    "3": { kayitId: "3", oran: 9.1, aciklama: "% 9.1" },
    "4": { kayitId: "4", oran: 11.38, aciklama: "% 11.38" },
    "5": { kayitId: "5", oran: 0.56, aciklama: "% 0.56" },
    "6": { kayitId: "6", oran: 1.1375, aciklama: "% 1.1375" },
    "7": { kayitId: "7", oran: 2.845, aciklama: "% 2.845" }
};

// Yardımcı sınıf
export class HarcMasrafDataHelper {
    static getHarcMasrafTurleri(yargiGiderTuru: string): HarcMasrafItem[] {
        switch (yargiGiderTuru) {
            case "H":
                return harcMasrafListJson.harcList;
            case "M":
                return harcMasrafListJson.masrafList;
            case "T":
                return harcMasrafListJson.tahsilatList;
            case "D":
                return harcMasrafListJson.digerList;
            default:
                return [];
        }
    }

    static calculateTutar(harcMasrafKod: string, girilenlTutar?: number): number {
        const allTypes = [
            ...harcMasrafListJson.harcList,
            ...harcMasrafListJson.tahsilatList,
            ...harcMasrafListJson.digerList
        ];
        
        const harcMasrafTuru = allTypes.find(x => x.harcMasrafKodStr === harcMasrafKod);
        
        if (!harcMasrafTuru) return 0;
        
        if (harcMasrafTuru.harcMasrafBedelMiOranMi === "B") {
            // Sabit bedel
            return parseFloat(String(harcMasrafTuru.tutar || harcMasrafTuru.harcMasrafBedel || "0"));
        } else if (harcMasrafTuru.harcMasrafBedelMiOranMi === "O" && girilenlTutar) {
            // Oran bazlı hesaplama
            const oran = parseFloat(harcMasrafTuru.harcMasrafOran || "0");
            return parseFloat((girilenlTutar * oran / 100).toFixed(2));
        }
        
        return 0;
    }

    static getTahsilHarcOranlari(): TahsilatHarcOrani[] {
        return Object.values(tahsilHarcOranlariListJson);
    }

    static findHarcMasrafByKod(harcMasrafKod: string): HarcMasrafItem | undefined {
        const allTypes = [
            ...harcMasrafListJson.harcList,
            ...harcMasrafListJson.tahsilatList,
            ...harcMasrafListJson.digerList
        ];
        
        return allTypes.find(x => x.harcMasrafKodStr === harcMasrafKod);
    }

    // Eski eIcrapro'dan form handling metodları
    static createDefaultFormData(): HarcMasrafFormData {
        return {
            harcMasraf: "",
            harcMasrafAdi: "",
            harcMasrafKod: "",
            harcMasrafKodStr: "",
            harcTip: "",
            harcMasrafOran: "",
            harcMasrafBedel: "",
            harcMasrafBedelMiOranMi: "",
            harcMasrafAltSiniri: "",
            adet: 1,
            tutar: "",
            toplamTutar: "",
            tutarDisabled: true,
            pesinHarcDisabled: true,
            harcOraniDisabled: true,
            otomatikIliskilendirmeText: ""
        };
    }

    static updateHarcMasrafTutari(harcMasrafKod: string, harcMasrafTurleri: HarcMasrafItem[]): HarcMasrafFormData {
        const harcMasrafTuru = harcMasrafTurleri.find(x => x.harcMasrafKodStr === harcMasrafKod);
        
        if (!harcMasrafTuru) {
            return this.createDefaultFormData();
        }

        const data: HarcMasrafFormData = {
            harcMasraf: harcMasrafTuru.harcMasraf || "",
            harcMasrafAdi: harcMasrafTuru.harcMasrafAdi,
            harcMasrafKod: harcMasrafTuru.harcMasrafKod || "",
            harcMasrafKodStr: harcMasrafTuru.harcMasrafKodStr,
            harcTip: harcMasrafTuru.harcTip || "",
            harcMasrafOran: harcMasrafTuru.harcMasrafOran || "",
            harcMasrafBedel: harcMasrafTuru.harcMasrafBedel || "",
            harcMasrafBedelMiOranMi: harcMasrafTuru.harcMasrafBedelMiOranMi,
            harcMasrafAltSiniri: harcMasrafTuru.harcMasrafAltSiniri || "",
            adet: harcMasrafTuru.adet,
            tutar: String(harcMasrafTuru.tutar),
            toplamTutar: String(harcMasrafTuru.tutar),
            tutarDisabled: true,
            pesinHarcDisabled: true,
            harcOraniDisabled: true,
            otomatikIliskilendirmeText: ""
        };

        // Oran bazlı mı bedel bazlı mı kontrolü
        if (data.harcMasrafBedelMiOranMi === "O") {
            data.pesinHarcDisabled = false;
        } else {
            data.pesinHarcDisabled = true;
        }

        if (data.harcMasrafBedelMiOranMi === "O" || data.tutar === "0") {
            data.tutarDisabled = false;
        } else {
            data.tutarDisabled = true;
        }

        // Tahsilat özel kontrolleri
        if (data.harcMasraf === "T") {
            if (harcMasrafTuru.tahsilatHarcOrani === "true") {
                data.harcOraniDisabled = false;
            }
            if (harcMasrafTuru.otomatikIliskilendirme === "true") {
                data.otomatikIliskilendirmeText = "Otomatik ilişkilendirme var";
            }
        } else {
            data.harcOraniDisabled = true;
        }

        return data;
    }

    static calculateTutarChange(formData: HarcMasrafFormData, girilenlTutar: string, adet: number): HarcMasrafFormData {
        const updatedData = { ...formData };
        
        // Currency formatını temizle
        let tutar = girilenlTutar.replace(",", ".");
        
        // Oran bazlı hesaplama varsa
        if (updatedData.harcMasrafOran && parseFloat(updatedData.harcMasrafOran) > 0) {
            tutar = (parseFloat(tutar) * parseFloat(updatedData.harcMasrafOran) / 100).toFixed(2);
        }
        
        updatedData.tutar = tutar;
        updatedData.toplamTutar = (parseFloat(tutar) * adet).toFixed(2);
        
        return updatedData;
    }
}